"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _reactEmotion = _interopRequireWildcard(require("react-emotion"));

var _emotionTheming = require("emotion-theming");

var _styleConsts = require("../../utils/styleConsts");

var expand =
/*#__PURE__*/
(0, _reactEmotion.keyframes)("from{max-height:0;}to{max-height:240px;}");

var styles = function styles(_ref) {
  var color = _ref.theme.color;
  return (
    /*#__PURE__*/
    (0, _reactEmotion.css)("position:relative;padding:0;z-index:1;max-height:240px;overflow-y:scroll;background-color:inherit;border-bottom:1px solid ", color.grey2, ";font-size:", _styleConsts.font.size.normal, ";list-style:none;transform-origin:bottom;animation:", expand, " .15s ease-in-out;")
  );
};

var _default = (0, _emotionTheming.withTheme)(
/*#__PURE__*/
(0, _reactEmotion.default)("ul", {
  target: "css-1w0t6wo0"
})(styles));

exports.default = _default;